import React from "react";
import LocaleStrings from "@language";
import facebookicon from "../../../assets/image/facebook.svg";
import { useSocialMedia } from "../../../hooks/useSocialMedia";

const FacebookButton = ({ onCompletion = (e) => {} }) => {
  const { handleFacebookLogin } = useSocialMedia(onCompletion);

  return (
    <button
      onClick={handleFacebookLogin}
      type="button"
      className={`FACEBOOK_BUTTON w-full h-10 px-4 py-2 gap-2 rounded-lg bg-[#1877F2] flex justify-center items-center`}
    >
      <img src={facebookicon} alt="Facebook Icon" />
      <div className="text-white text-sm font-medium text-nowrap">
        {LocaleStrings.kFacebookloginButton}
      </div>
    </button>
  );
};
export default FacebookButton;
